(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lanoel-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lanoel-benefit-banner')) {
  customElements.define('lanoel-benefit-banner', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const toggle = this.querySelector('.lnm__toggle');
      const items = [...this.querySelector('.lnm__group').children];
      const count = this.querySelector('.lnm__sr').children.length;
      let index = 0;
      const reset = () => {
        items.forEach((item, i) => item.toggleAttribute('data-current', i === index));
      };
      reset();
      this.timer = setInterval(() => {
        if (!this.motion.matches || toggle.checked || document.hidden || count < 2) return;
        if (matchMedia('(hover: hover) and (pointer: fine)').matches && this.matches(':hover')) return;
        index = (index + 1) % count;
        reset();
      }, 5000);
      this.motion.addEventListener('change', reset, options);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
